<style>
        .cookiesBox{
            background: rgba(0,0,0,.8); overflow: hidden;
            position:fixed;
            display: block; width: 100vw;
            bottom: 0;
            z-index: 99;
        }
        .cookiesBox .text{ display: block; width:78%;position: relative; overflow: hidden;margin: auto;; }
        .cookiesBox h3{padding:0px 0px 0px; margin:10px 20px 10px 10px;display: inline-block; text-align:center;  color:#0cf; font-size:1.2em;font-weight:300; border-bottom: 3px solid #0cf;}
        .cookiesBox p{color:#fff; font-size: 0.9em;line-height: 1.2;
         overflow: hidden; margin:0 0px 15px 15px;width:calc(100% - 150px);}
         .cookiesBox p a{ color:#0cf; text-decoration: underline;}
        .cookiesBox p .btn-OK{background:#09f; display:inline-block;
            text-align: center; color:white; text-decoration:none;
            border-radius:3px; position: absolute; content:'';
            top:0;bottom: 0;right: 20px;margin:auto;width: 90px;
            height: 25px;
            line-height: 25px; }
        @media only screen and (max-width: 767px){
            .cookiesBox{
                width: 96vw; padding:2vw;margin-top: 50px;
                position: fixed;z-index: 5;
            }
            .cookiesBox .text{ width: 96vw;}
            .cookiesBox p{width: 100%;position: relative;}
            .cookiesBox p a{line-height: 35px;}
            .cookiesBox p .btn-OK{
                position: static;float: right;color:white;text-decoration:none;
                border-radius:15px;margin-top: 4px;
            }
            .cookiesBox h3,.cookiesBox p{margin:0 0 5px 0;}
        }
</style>

<div class="cookiesBox" *ngIf="isShow">
    <div class="text">
        <h3>Cookies</h3>
        <p>{{msg}}
            <a href="https://officeportal.taiwantrade.com/cookies.html" target="_blank">{{url_info}}</a>
            <a routerLink="" class="btn-OK" (click)="Agree()">OK</a>
        </p>
    </div>
    
</div>